export default __webpack_public_path__ + "static/media/Connect.0155b54a.png";